import { render, staticRenderFns } from "./ErhebungsArt.vue?vue&type=template&id=0f14f8aa&"
import script from "./ErhebungsArt.vue?vue&type=script&lang=ts&"
export * from "./ErhebungsArt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports